import React from 'react'
import Datetime from 'react-datetime'
import clsx from 'clsx'
import useViewModel from './ViewModel'

const ProjectInfoView: React.FC = () => {
  const {
    isSubmitting,
    formState,
    hasEdit,
    projectState,
    onChangeFormState,
    onSubmit,
    onOpenproject,
    onCloseproject,
  } = useViewModel()

  return (
    <React.Fragment>
      <div className='row mb-5 gy-5'>
        <div className='col-12'>
          <div className='card h-100'>
            <div className='card-body'>
              <div className='row gy-5 py-7'>
                <div className='col-12 text-end'>
                  {projectState === 'pending' && (
                    <button onClick={onOpenproject} className='btn btn-success'>
                      เปิดโครงการ
                    </button>
                  )}
                  {projectState === 'in-progress' && (
                    <button onClick={onCloseproject} className='btn btn-danger'>
                      ปิดโครงการ
                    </button>
                  )}
                </div>
              </div>
              <div className='row gy-5 py-7'>
                {/* begin:: Start Job Date */}
                <div className='col-12 col-xl-3'>
                  <label htmlFor='poNo' className='fs-6 mb-1 fw-bold'>
                    วันที่เริ่มงาน
                  </label>

                  <Datetime
                    timeFormat={false}
                    dateFormat='DD/MM/YYYY'
                    renderInput={props => (
                      <input
                        {...props}
                        autoComplete='off'
                        name='startJobDate'
                        className={clsx('form-control form-control-sm', {})}
                      />
                    )}
                    onChange={selectedDate => {
                      if (selectedDate) onChangeFormState('startJobDate', selectedDate)
                    }}
                    value={formState.startJobDate}
                  />
                </div>

                <div className='col-12 col-xl-3'>
                  <label htmlFor='poNo' className='fs-6 mb-1 fw-bold'>
                    วันที่งานสิ้นสุด
                  </label>

                  <Datetime
                    timeFormat={false}
                    dateFormat='DD/MM/YYYY'
                    renderInput={props => (
                      <input
                        {...props}
                        autoComplete='off'
                        name='endJobDate'
                        className={clsx('form-control form-control-sm', {})}
                      />
                    )}
                    onChange={selectedDate => {
                      if (selectedDate) onChangeFormState('endJobDate', selectedDate)
                    }}
                    value={formState.endJobDate}
                  />
                </div>

                <div className='col-12 col-xl-3'>
                  <label htmlFor='poNo' className='fs-6 mb-1 fw-bold'>
                    จำนวนเสาตั้งต้นที่คาดการณ์
                  </label>

                  <input
                    type='number'
                    min={0}
                    className={clsx('form-control form-control-sm', {})}
                    value={formState.totalExpectPile}
                    onChange={e => onChangeFormState('totalExpectPile', e.target.value)}
                  />
                </div>
              </div>
            </div>

            <div className='card-footer text-end py-5'>
              <button
                className={clsx('btn ', {
                  'btn-secondary': isSubmitting || !hasEdit,
                  'btn-primary': !isSubmitting && hasEdit,
                })}
                disabled={isSubmitting || !hasEdit}
                onClick={onSubmit}>
                บันทึก
              </button>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  )
}

export default ProjectInfoView
